import { motion } from "framer-motion";

// Simulates a "plotter draws the line-art" reveal on a raster image:
// a cover panel slides off left-to-right (transform-based, reliable) with a glowing
// neon "pen" edge, as the image scrolls into view (once). Parent must be relative.
export function DrawReveal({ src, alt, imgClassName = "", cover = "#050505", duration = 1.2, amount = 0.35 }) {
  const ease = [0.22, 1, 0.36, 1];
  return (
    <>
      <img src={src} alt={alt} loading="lazy" className={imgClassName} />
      <motion.div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{ backgroundColor: cover }}
        initial={{ x: "0%" }}
        whileInView={{ x: "101%" }}
        viewport={{ once: true, amount }}
        transition={{ duration, ease }}
      />
      <motion.span
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 w-[2px] bg-neon"
        style={{ boxShadow: "0 0 14px 2px rgba(152,255,86,0.85)" }}
        initial={{ left: "0%", opacity: 0 }}
        whileInView={{ left: "100%", opacity: [0, 1, 1, 0] }}
        viewport={{ once: true, amount }}
        transition={{ duration, ease, opacity: { duration, times: [0, 0.08, 0.92, 1] } }}
      />
    </>
  );
}
